namespace TabAurous.Purchase {
    export namespace OrderItemsService {
        export const baseUrl = 'Purchase/OrderItems';

        export declare function Create(request: Serenity.SaveRequest<OrderItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<OrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<OrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ValidateQuotation(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<OrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/OrderItems/Create",
            Update = "Purchase/OrderItems/Update",
            Delete = "Purchase/OrderItems/Delete",
            Retrieve = "Purchase/OrderItems/Retrieve",
            List = "Purchase/OrderItems/List",
            CustomList = "Purchase/OrderItems/CustomList",
            ValidateQuotation = "Purchase/OrderItems/ValidateQuotation"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'ValidateQuotation'
        ].forEach(x => {
            (<any>OrderItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
